import { render, staticRenderFns } from "./BasBankAccountModal.vue?vue&type=template&id=2c1fc012&scoped=true&"
import script from "./BasBankAccountModal.vue?vue&type=script&lang=js&"
export * from "./BasBankAccountModal.vue?vue&type=script&lang=js&"
import style0 from "./BasBankAccountModal.vue?vue&type=style&index=0&id=2c1fc012&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1fc012",
  null
  
)

export default component.exports